export default __webpack_public_path__ + "static/media/kilauea.520d6458.glb";